var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStraightPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "straight-point") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "straight-point",
    fill: "#4C97FF"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#4C97FF",
    strokeWidth: 0.75,
    fillOpacity: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "2 15 10 7 18 15"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    fillOpacity: 0.25,
    cx: 10,
    cy: 7,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    cx: 10,
    cy: 7,
    r: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStraightPoint);
export default __webpack_public_path__ + "static/media/straight-point.c5bdca3dad692d576d121f04d946a60f.svg";
export { ForwardRef as ReactComponent };